// @flow
import React from 'react'
import classNames from 'classnames/bind'
import { useTranslation } from 'react-i18next'

import { Td, Tr, getPropsHeader } from 'app/common/ui-components/table'
import Pdf32 from 'app/common/icons/pdf32.svg'
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link'
// import PlainLink from 'app/common/ui-next/plain-link';

import { columnsIds } from './PaymentOrdersTHead'
import usePaymentOrderPdf from './usePaymentOrderPdf'
import styles from './PaymentOrdersTableRowItem.module.scss';

const cx = classNames.bind(styles)

type Props = {
  loading: boolean,
  id: number,
  personId: number,
  number: string,
  period: string,
  amount: string,
  expired: string,
  getPaymentPath?: (s: string) => string,
}

const PaymentOrdersTableRowItem = ({ loading, id, personId, number, period, amount }: Props) => {
  const { t } = useTranslation('finances')
  const [requestPdf, loadingLink] = usePaymentOrderPdf(personId, id, `${number}_${personId}`)
  const headers = getPropsHeader()

  return (
    <Tr disabled={loading} className={styles.root}>
      <Td {...headers(columnsIds[0])}>{period}</Td>
      <Td {...headers(columnsIds[1])}>{amount}</Td>
      {/* <Td {...headers(columnsIds[2])}>{expired}</Td> */}
      <Td {...headers(columnsIds[3])} alignCenter>
        <PlainButtonAsLink onClick={requestPdf} disabled={loadingLink || loading}>
          <Pdf32 className={cx({ loadingLink })} />
        </PlainButtonAsLink>
      </Td>
      <Td {...headers(columnsIds[3])} alignRight>
        <PlainButtonAsLink onClick={requestPdf} disabled={loadingLink || loading}>
          {t('link_download', 'Скачать')}
        </PlainButtonAsLink>
        {/* Скрыто временно */}
        {/* <PlainLink
          to={getPaymentPath(amount)}
          disabled={loading}
          className={styles.payLink}
        >
          {t('link_pay', 'Оплатить')}
        </PlainLink> */}
      </Td>
    </Tr>
  )
}

export default PaymentOrdersTableRowItem
